import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import throttle from 'lodash/throttle';
import { Decoration, DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { fg } from '@atlaskit/platform-feature-flags';
import { updateInlineSuggestion } from '../commands/commands';
import { getPluginState as getInlineSuggestionsPluginState } from '../plugin-factory';
import { dateSuggestionHandler } from './date/date';
import { TextPhraseExtractor } from './utils';
export var SuggestionManager = /*#__PURE__*/function () {
  function SuggestionManager() {
    var _this = this;
    _classCallCheck(this, SuggestionManager);
    _defineProperty(this, "THROTTLE_MS", 100);
    _defineProperty(this, "handlers", [dateSuggestionHandler]);
    _defineProperty(this, "throttledDetection", throttle(function (view) {
      var state = view.state,
        dispatch = view.dispatch;
      var pluginState = getInlineSuggestionsPluginState(state);
      var prevSug = pluginState.inlineSuggestion;
      var prevDecos = pluginState.decorationSet;
      var cursorPhrases = TextPhraseExtractor.getTextPhrasesAroundCursor(state);
      var currSug = _this.detectFirstSuggestion(state, cursorPhrases);
      var isNoSuggestionChange = prevSug === null && currSug === null;
      if (isNoSuggestionChange) {
        return;
      }
      var updatedDecos = _this.rebuildSuggestionDecorations(currSug, state, prevDecos);
      updateInlineSuggestion(currSug, updatedDecos)(state, dispatch);
    }, this.THROTTLE_MS, {
      leading: false,
      trailing: true
    }));
  }
  return _createClass(SuggestionManager, [{
    key: "detectFirstSuggestion",
    value: function detectFirstSuggestion(state, cursorPhrases) {
      var _iterator = _createForOfIteratorHelper(this.handlers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var handler = _step.value;
          var match = handler.detect(state, cursorPhrases);
          if (match) {
            var node = handler.createReplacement(match, state.schema);
            return _objectSpread(_objectSpread({}, match), {}, {
              suggestedNode: node
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "scheduleScanForSuggestions",
    value: function scheduleScanForSuggestions(view) {
      this.throttledDetection(view);
    }
  }, {
    key: "cancelSuggestionScans",
    value: function cancelSuggestionScans() {
      this.throttledDetection.cancel();
    }
  }, {
    key: "createMarkerDecoration",
    value: function createMarkerDecoration(marker) {
      var addClass = SuggestionManager.INLINE_SUGGESTION_DECORATION_CLASSES[marker.style];
      var decoClass = [marker.cssClass, addClass].filter(Boolean).join(' ');
      return Decoration.inline(marker.from, marker.to, {
        class: decoClass.trim()
      });
    }

    /**
     * Creates an inline decoration whose DOM element serves as a positioning
     * anchor for the Suggestion popup (i.e. the floating toolbar).
     */
  }, {
    key: "createToolbarDecoration",
    value: function createToolbarDecoration(from, to) {
      return Decoration.inline(from, to, {
        class: SuggestionManager.INLINE_SUGGESTION_DECORATION_CLASSES.toolbarAnchor
      });
    }
  }, {
    key: "createCompletionHintDecorations",
    value: function createCompletionHintDecorations(suggestion, state) {
      var handler = this.handlers.find(function (handler) {
        return handler.type === suggestion.type;
      });
      if (handler && handler.createCompletionHint) {
        var hint = handler.createCompletionHint(suggestion, state);
        if (hint) {
          return [Decoration.widget(suggestion.to, function () {
            var container = document.createElement('span');
            container.className = [SuggestionManager.INLINE_SUGGESTION_DECORATION_CLASSES.completionHint, SuggestionManager.INLINE_SUGGESTION_DECORATION_CLASSES.underline, SuggestionManager.INLINE_SUGGESTION_DECORATION_CLASSES.highlight].join(' ');
            var textSpan = document.createElement('span');
            textSpan.textContent = hint.hintText;
            container.appendChild(textSpan);
            return container;
          }, {
            side: 1,
            type: SuggestionManager.DECORATION_TYPES.completionHint
          })];
        }
      }
      return [];
    }
  }, {
    key: "rebuildSuggestionDecorations",
    value: function rebuildSuggestionDecorations(suggestion, state, prevDecoSet) {
      var _this2 = this;
      if (!suggestion) {
        return DecorationSet.empty;
      }
      var regionDecos = prevDecoSet.find(suggestion.from, suggestion.to);
      var cleanSet = prevDecoSet.remove(regionDecos);
      var handler = this.handlers.find(function (handler) {
        return handler.type === suggestion.type;
      });
      if (!handler) {
        return cleanSet;
      }
      var markers = handler.createMarkers(suggestion, state);
      var markerDecos = markers.map(function (marker) {
        return _this2.createMarkerDecoration(marker);
      });
      var toolbarDeco = this.createToolbarDecoration(suggestion.from, suggestion.to);
      var newDecos = [].concat(_toConsumableArray(markerDecos), [toolbarDeco]);
      if (fg('platform_editor_ai_suggestions_completion_hints')) {
        var hintDecos = this.createCompletionHintDecorations(suggestion, state);
        newDecos.push.apply(newDecos, _toConsumableArray(hintDecos));
      }
      return cleanSet.add(state.doc, newDecos);
    }
  }]);
}();
_defineProperty(SuggestionManager, "INLINE_SUGGESTION_DECORATION_CLASSES", {
  underline: 'proactive-ai-inline-suggestion-underline',
  highlight: 'proactive-ai-inline-suggestion-highlight',
  toolbarAnchor: 'proactive-ai-inline-suggestion-floating-toolbar-anchor',
  completionHint: 'proactive-ai-inline-suggestion-completion-hint'
});
_defineProperty(SuggestionManager, "DECORATION_TYPES", {
  completionHint: 'completionHint'
});
export var suggestionManager = new SuggestionManager();